import { SxProps } from "@mui/material";

const CreditNoteReceiptStyles: Record<string, SxProps> = {
  root: {
    padding: "20px",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
  },
  title: {
    fontWeight: "500",
    marginBottom: "44px",
    fontSize: "20px",
  },
  actionIconsWrapper: {
    display: "flex",
    justifyContent: "space-between",
    gap: "20px",
  },
  icon: {
    width: "24px",
    height: "24px",
    cursor: "pointer",
  },
  tableWrapper: {
    backgroundColor: "white",
    padding: 8,
  },
  tableContainer: {
    borderRadius: "0 !important",
  },
  table: {
    "& .MuiTableCell-root.MuiTableCell-root": { padding: "0px" },
    border: "3px solid black",
  },
  tableHeadCell: {
    borderBottom: "none",
  },
  tableBodyCell: {
    padding: 0,
  },
};

export default CreditNoteReceiptStyles;
